// Module
var code = `<label class="toggle">
  <input type="checkbox" />
  <span class="marker"></span>
  <span class="label"></span>
</label>
`;
// Exports
export default code;